<template>
  <div id="funcionalidade-customizada-historico">
    <FuncionalidadeHeader
      :titulo="tituloNavegacao"
    />
    <SolicitacaoHistorico
      :chave-externa="'ocorrencias'"
      :funcionalidade="funcionalidade"
      :lista-externa="listaComData"
      :rota-detalhe="rotaDetalhe"
    >
      <template v-slot:default="{card}">
        <div
          @click="onClickRow(card)"
        >
          <ListaExtratoCard
            :card="card"
          />
        </div>
      </template>
    </SolicitacaoHistorico>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import SolicitacaoHistorico from '@/components/TemplateSolicitacao/SolicitacaoHistorico'
import ListaExtratoCard from '@/components/TemplateSolicitacao/componentes/ListaExtratoCard'

export default {
  name: 'FuncionalidadeCustomizadaHistorico',
  components: {
    SolicitacaoHistorico,
    FuncionalidadeHeader,
    ListaExtratoCard
  },
  data () {
    return {
      contratosList: []
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapGetters('Login', ['user']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    listaComData () {
      let data = []
      this.contratosList.map((obj) => {
        const tempLista = obj.ocorrencias.map((el) => {
          return {
            ...el,
            cardExterno: true
          }
        })
        data.push({
          numeroContrato: obj.numeroContrato,
          extrato: tempLista
        })
      })
      return data
    },
    rotaDetalhe () {
      return `/${this.funcionalidade.idFuncionalidade}/detalhe`
    }
  },
  methods: {
    async init () {
    }
    /* async listaDados () {
      let result = await this.apiFuncionalidade.lista({
        payload: {
          integracao: this.user.integracao,
          chaveUnica: this.user.chaveUnica,
          dataInicial: '2021-03-01',
          dataFinal: '2021-01-31'
        }
      })
      this.contratosList = result.data.contratos
    },
    onClickRow (row) {
      return this.$router.push({
        path: `/${this.funcionalidade.idFuncionalidade}/detalhe`,
        query: {
          idOcorrencia: row['idReembolso']
        }
      })
    } */
  },
  mounted () {
    this.init()
  }
}
</script>
